// Dynamic styles based on theme - to be used with useThemedStyles.
export const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	row: {
		width: '100%',
		paddingVertical: space.md,
		paddingHorizontal: space.gutter,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
		backgroundColor: colors.canvas,
	},
	rowInactive: {
		backgroundColor: colors.card,
		opacity: 0.6,
	},
	rowMain: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 10,
	},
	rowMainStacked: {
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: space.md,
	},
	info: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: 10,
	},
	slot: {
		width: 42,
		alignItems: 'center',
	},
	slotText: {
		...type.cardTitle,
		lineHeight: 22,
		color: colors.text,
	},
	imageColumn: {
		alignSelf: 'center',
	},
	productImg: {
		width: 48,
		height: 48,
		resizeMode: 'contain', // Fits image into container with correct aspect ratio
	},
	details: {
		flex: 1,
		minWidth: 0,
		gap: 6,
	},
	productName: {
		...type.bodyStrong,
		color: colors.text,
	},
	removedProductName: {
		...type.secondary,
		color: colors.textSecondary,
	},
	boxes: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: 6,
	},
	box: {
		...type.bodySmallStrong,
		color: colors.text,
		borderWidth: 1.5,
		borderColor: colors.icon,
		borderRadius: radius.tag,
		paddingVertical: 1,
		paddingHorizontal: 6,
		overflow: 'hidden',
	},
	boxPriceMismatch: {
		backgroundColor: colors.dangerSolid,
		borderColor: colors.dangerSolid,
		color: colors.onDangerSolid,
	},
	boxQueuedPrice: {
		backgroundColor: colors.warningBg,
		borderColor: colors.warningBorder,
		color: colors.warning,
	},
	pickControls: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.xs,
	},
	requiredButton: {
		minWidth: 32,
		minHeight: 44,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	required: {
		...type.cardTitle,
		color: colors.text,
		textAlign: 'right',
	},
	extraQuantity: {
		color: colors.success,
	},
	missingQuantityButton: {
		minWidth: 36,
		height: 32,
		paddingHorizontal: space.sm,
		borderRadius: radius.pill,
		backgroundColor: colors.primary,
		alignItems: 'center',
		justifyContent: 'center',
	},
	missingQuantityText: {
		...type.bodySmallSemibold,
		color: colors.onPrimary,
	},
	actionsSide: {
		alignSelf: 'center',
	},
	actionsStacked: {
		alignSelf: 'stretch',
	},
	footer: {
		marginTop: 6,
		alignItems: 'flex-end',
		gap: 2,
	},
	footerText: {
		...type.caption,
		color: colors.textSecondary,
		textAlign: 'right',
	},
	missingQuantityExplanation: {
		...type.caption,
		fontStyle: 'italic',
		color: colors.warning,
		textAlign: 'right',
	},
	expiryDatesContainer: {
		alignSelf: 'stretch',
		alignItems: 'flex-end',
		gap: space.xs,
	},
});
